export const mockChargingStations = {
  'plaza-001': [
    { id: 'charger-001', name: 'Charger A1', status: 'NOT_CONNECTED' },
    { id: 'charger-002', name: 'Charger A2', status: 'CONNECTED_CHARGING' },
    { id: 'charger-003', name: 'Charger A3', status: 'CONNECTED_NOT_CHARGING' },
    { id: 'charger-004', name: 'Charger A4', status: 'FAULTED' },
  ],
  'plaza-002': [
    { id: 'charger-005', name: 'Charger B1', status: 'CONNECTED_CHARGING' },
    { id: 'charger-006', name: 'Charger B2', status: 'NOT_CONNECTED' },
    { id: 'charger-007', name: 'Charger B3', status: 'CONNECTED_NOT_CHARGING' },
  ],
  'plaza-003': [
    { id: 'charger-008', name: 'Charger C1', status: 'UNKNOWN' },
    { id: 'charger-009', name: 'Charger C2', status: 'UNKNOWN' },
  ],
  'plaza-004': [
    { id: 'charger-010', name: 'Charger D1', status: 'RESERVED_CABLE_DISCONNECTED' },
    { id: 'charger-011', name: 'Charger D2', status: 'RESERVED_CABLE_DISCONNECTED' },
    { id: 'charger-012', name: 'Charger D3', status: 'NOT_CONNECTED' },
  ],
  'plaza-005': [
    { id: 'charger-013', name: 'Charger E1', status: 'FAULTED' },
    { id: 'charger-014', name: 'Charger E2', status: 'CONNECTED_NOT_CHARGING' },
  ],
  'plaza-006': [
    { id: 'charger-015', name: 'Charger F1', status: 'CONNECTED_CHARGING' },
    { id: 'charger-016', name: 'Charger F2', status: 'NOT_CONNECTED' },
    { id: 'charger-017', name: 'Charger F3', status: 'CONNECTED_NOT_CHARGING' },
    { id: 'charger-018', name: 'Charger F4', status: 'CONNECTED_CHARGING' },
  ],
  'plaza-007': [
    { id: 'charger-019', name: 'Charger G1', status: 'NOT_CONNECTED' },
    { id: 'charger-020', name: 'Charger G2', status: 'CONNECTED_NOT_CHARGING' },
  ],
  'plaza-008': [
    { id: 'charger-021', name: 'Charger H1', status: 'CONNECTED_CHARGING' },
    { id: 'charger-022', name: 'Charger H2', status: 'NOT_CONNECTED' },
    { id: 'charger-023', name: 'Charger H3', status: 'RESERVED_CABLE_DISCONNECTED' },
  ],
};
